import type { OverallHealthStatus } from '@/types'

interface HealthBadgeProps {
  status: OverallHealthStatus
  pulse?: boolean
  size?: number
}

const STATUS_COLORS: Record<OverallHealthStatus, string> = {
  healthy: 'var(--status-healthy)',
  degraded: 'var(--status-warning)',
  unhealthy: 'var(--status-unhealthy)',
  unreachable: 'var(--status-unknown, var(--text-tertiary))',
}

export function HealthBadge({ status, pulse, size = 8 }: HealthBadgeProps) {
  const color = STATUS_COLORS[status] ?? 'var(--text-tertiary)'
  const shouldPulse = pulse ?? (status === 'healthy' || status === 'degraded')
  return (
    <span
      className={shouldPulse ? 'animate-pulse-dot' : undefined}
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        flexShrink: 0,
      }}
      title={status}
    />
  )
}
